import type { AxiosRequestConfig } from "axios";
import type { IPaginated, IRepositoryOptions } from "@/types/common";
import type { IAdmin } from "@/types/users-admins";
import { BaseRepository } from "../BaseRepository";
import type { AdminsService } from "./service";
import type {
  IDeleteAdminRequest,
  IGetAdminProfileByUserIdRequest,
  IGetAdminsRequest,
} from "./types";

export class AdminsRepository extends BaseRepository {
  constructor(
    private readonly service: AdminsService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getAll(
    p: IGetAdminsRequest,
    c?: AxiosRequestConfig,
  ): Promise<IPaginated<IAdmin>> {
    const response = await this.handleRequest(this.service.getAll, p, c);
    return response.data;
  }

  async getProfileByUserId(
    p: IGetAdminProfileByUserIdRequest,
    c?: AxiosRequestConfig,
  ): Promise<IAdmin> {
    const response = await this.handleRequest(
      this.service.getProfileByUserId,
      p,
      c,
    );
    return response.data;
  }

  async deleteAdmin(
    p: IDeleteAdminRequest,
    c?: AxiosRequestConfig,
  ): Promise<void> {
    const response = await this.handleRequest(this.service.deleteAdmin, p, c);
    return response.data;
  }
}
